import React from 'react';
import { Box } from '@mui/material';

import ChartContainer from './ChartContainer';

/**
 * IndicatorChart - Wrapper for indicator chart display
 * Manages differential display between screen and print
 *
 * @param {Object} props - Component props
 * @param {string} props.screenType - Screen type (smallScreen, mediumScreen, largeScreen)
 * @param {string} [props.domain] - Territory domain for season tooltips
 * @param {...Object} rest - Other props passed to ChartContainer
 * @returns {React.ReactElement} Chart container with responsive and print management
 */
const IndicatorChart = ({
  screenType,
  domain,
  ...rest
}) => (
  <>
    {/* Normal screen display */}
    <Box sx={{ displayPrint: 'none' }}>
      <ChartContainer
        isSingleSeasonRow={screenType === 'smallScreen'}
        screenType={screenType}
        domain={domain}
        {...rest}
      />
    </Box>

    {/* Print display */}
    <Box sx={{ displayPrint: 'block', display: 'none' }}>
      <ChartContainer
        isPrint
        domain={domain}
        {...rest}
      />
    </Box>
  </>
);

IndicatorChart.displayName = 'IndicatorChart';

export default React.memo(IndicatorChart);
